"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsScrollLink = exports.SCROLL_LINK_HREF_REGEX = void 0;
const SCROLL_LINK_HREF_REGEX = exports.SCROLL_LINK_HREF_REGEX = /#([^?]+)/;
const getIsScrollLink = url => SCROLL_LINK_HREF_REGEX.test(url);
exports.getIsScrollLink = getIsScrollLink;
//# sourceMappingURL=utils.js.map